module.exports = __webpack_public_path__ + "assets/img/00004.7ca414df.png";